import axios from "axios"
// // analytics.js (utility file in your React project)
// import { createClient, OAuthStrategy } from '@wix/sdk';

// // Use only the public Client ID in the front end, not the Client Secret
// const clientId = process.env.REACT_APP_WIX_CLIENT_ID;

// // If you're using OAuth, you'd typically need a short-lived access token or session token from Wix
// // In a more advanced setup, you might handle a user session token after they log in 
// // For demonstration, let's assume an ephemeral token is fetched from your server or from Wix.

// const getAccessToken = async () => {
//     // Pseudocode to fetch an access token from your server or from a Wix login flow
//     const token = await fetch('/api/get-wix-token').then(res => res.text());
//     return token;
// };

// export async function logEventToWix(eventType, eventPayload) {
//     try {
//         const accessToken = await getAccessToken();

//         const wixClient = createClient({
//             modules: { events },
//             auth: OAuthStrategy({
//                 clientId,
//                 tokens: { accessToken },
//             }),
//         });

//         // The "events" module is just an example. 
//         // Depending on Wix's current Headless offerings, you might be calling a "analytics" or "customEvents" module
//         const result = await wixClient.events.createEvent({
//             type: eventType,
//             data: eventPayload,
//             // Possibly other fields depending on the API
//         });

//         console.log('Wix event logged:', result);
//     } catch (err) {
//         console.error('Error logging event to Wix:', err);
//     }
// }

export function logtoWix(userid, event_type, url, event_data) {

    axios({
        method: 'post',
        url: "https://n3rve.fly.dev/log-event",
        data: {
            title: userid,
            event_type: event_type,
            url: url,
            event_data: event_data,
            date: wixNow()
        }
    }).then(res => {
        console.log("Wix Log Uploaded")
        console.log(res)
    }).catch(e => {
        console.log(e)
    })


}

function wixNow(d = new Date()) {
    return { $date: d.toISOString() };
}

function formatMMDDYYYYHHmm(date) {
    const pad2 = n => String(n).padStart(2, '0');

    const month = pad2(date.getMonth() + 1);   // months are 0–11
    const day = pad2(date.getDate());
    const year = date.getFullYear();

    const hours = pad2(date.getHours());     // 0–23 for 24‑hour format
    const minutes = pad2(date.getMinutes());

    return `${month}/${day}/${year} ${hours}:${minutes}`;
}